import { CardContent } from "@material-ui/core";

const IndividualComment = (props) => {
  const { comment, commentID } = props;
  return <CardContent key={commentID}>{comment}</CardContent>;
};

export default IndividualComment;
